import styled, { css } from 'styled-components';

import { ViewModeQueries } from '@helpers/viewModeHelper';

const WrapLink = styled.a`
  text-decoration: none;
`;

const Wrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  gap: 10px 0;
`;

const ImageWrap = styled.div`
  position: relative;
  width: 100%;
  height: auto;

  > img {
    width: 100%;
    height: 555px;
  }
`;

const AbsoluteLink = styled.a<{ index: number }>`
  position: absolute;
  z-index: 2;

  ${(props) =>
    props.index === 1 &&
    css`
      top: 0;
      left: 0;
      width: 100%;
      height: 57%;

      ${ViewModeQueries.SM} {
        height: 73%;
      }
    `}

  ${(props) =>
    props.index === 2 &&
    css`
      top: 58%;
      left: 0;
      width: 100%;
      height: 21%;

      ${ViewModeQueries.SM} {
        top: 74%;
        left: 11%;
        width: 31%;
        height: 25.5%;
      }
    `}

  ${(props) =>
    props.index === 3 &&
    css`
      top: 79.7%;
      left: 0;
      width: 100%;
      height: 20%;

      ${ViewModeQueries.SM} {
        top: 74%;
        left: 53%;
        width: 37%;
        height: 25.5%;
      }
    `}
`;

const Link = styled.a`
  background-color: #c0589d;
  color: #ffffff;
  border-radius: 4px;
  padding: 10px 15px;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;

  ${ViewModeQueries.SM} {
    font-size: 16px;
  }
`;

const ShopText = styled.div`
  color: #0062aa;
  width: 100%;
  text-align: center;
  font-size: 10px;
  margin-top: 10px;

  ${ViewModeQueries.SM} {
    font-size: 14px;
  }
`;

const ExtraText = styled.div`
  color: #0062aa;
  width: 100%;
  text-align: center;
  font-size: 10px;
  margin-top: 0;

  ${ViewModeQueries.SM} {
    font-size: 14px;
  }
`;

const StepsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px 0;
  padding-left: 25px;
`;

const Step = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  gap: 0 15px;
`;
const Text = styled.div`
  color: #0062aa;
  font-size: 15px;
  font-weight: 400;

  ${ViewModeQueries.SM} {
    font-size: 25px;
  }
`;

const Bold = styled.span`
  font-weight: 600;
`;

const Bubble = styled.div`
  background-color: #c0589d;
  color: #ffffff;
  font-weight: 700;
  font-size: 10px;
  width: 21px;
  height: 21px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;

  ${ViewModeQueries.SM} {
    width: 31px;
    height: 31px;
    font-size: 20px;
  }
`;

export { WrapLink, Wrapper, ImageWrap, AbsoluteLink, Link, StepsWrap, Step, Text, Bold, Bubble, ShopText, ExtraText };
